module.exports = __webpack_public_path__ + "static/media/full_face.9eeca06a.png";